//
// Accordion BS4 based
//


var fn_accordion_fx = function () {
    // Opens accordion automatically if an accordion target (URL HASH is ID of Collapsable Item) is accessed from another page
    // Delaying Opening of Collapse coz of IE
    $(window).on("load", function () {
        $.ready.then(function () {
            // Both ready and loaded
            if (window.location.hash) {
                var jQuerytarget = jQuery('body').find(window.location.hash);

                if (jQuerytarget.hasClass('collapse')) {
                    var jQuerytargetAccordion = jQuerytarget.find('.collapse');
                    jQuerytarget.collapse('show');
                }

            }
            //
        });
    })


    // Opens Collapse on Event Master page with just 1 Event
    $(window).on('load', function () {

       if ( $('body').hasClass('page-node-type-event-master') ) {

          $('.event-is-solo .accordion-item__body').collapse('show');

       }


    });
    //

};
